export default __webpack_public_path__ + "media/flags/ne-cb75972c.svg";